export const firebaseConfig = {
  apiKey: "AIzaSyBJUYf7-IOv9Md2WH_sy7MaXzoa1FpNnRA",
  authDomain: "the-corner-dental-prac.firebaseapp.com",
  projectId: "the-corner-dental-prac",
  storageBucket: "the-corner-dental-prac.appspot.com",
  messagingSenderId: "768874992525",
  appId: "1:768874992525:web:3d4f540b17cc831d6023c4",
  measurementId: "G-8KRT3KE4FY"
};